/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import { FilterItems, FavouriteFilters } from "../Search/Filter";

export interface PriceRange {
  count: number;
  priceMin: number;
  priceMax: number;
  step: number;
}

export interface PriceRangeInfo {
  minPrice: number;
  maxPrice: number;
  priceRangeList: PriceRange[];
}

export interface FilterList {
  items?: FilterItems;
  /**
   * legacy data structure for desktop search form, will be removed if search form is reimplemented in react
   *
   * @deprecated
   */
  favouriteFilters?: FavouriteFilters;
  priceRange?: PriceRangeInfo;
}

function createBasePriceRange(): PriceRange {
  return { count: 0, priceMin: 0, priceMax: 0, step: 0 };
}

export const PriceRange = {
  encode(
    message: PriceRange,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.count !== 0) {
      writer.uint32(8).uint32(message.count);
    }
    if (message.priceMin !== 0) {
      writer.uint32(21).float(message.priceMin);
    }
    if (message.priceMax !== 0) {
      writer.uint32(29).float(message.priceMax);
    }
    if (message.step !== 0) {
      writer.uint32(45).float(message.step);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PriceRange {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePriceRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.count = reader.uint32();
          break;
        case 2:
          message.priceMin = reader.float();
          break;
        case 3:
          message.priceMax = reader.float();
          break;
        case 5:
          message.step = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PriceRange {
    return {
      count: isSet(object.count) ? Number(object.count) : 0,
      priceMin: isSet(object.priceMin) ? Number(object.priceMin) : 0,
      priceMax: isSet(object.priceMax) ? Number(object.priceMax) : 0,
      step: isSet(object.step) ? Number(object.step) : 0,
    };
  },

  toJSON(message: PriceRange): unknown {
    const obj: any = {};
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.priceMin !== undefined && (obj.priceMin = message.priceMin);
    message.priceMax !== undefined && (obj.priceMax = message.priceMax);
    message.step !== undefined && (obj.step = message.step);
    return obj;
  },

  fromPartial(object: DeepPartial<PriceRange>): PriceRange {
    const message = createBasePriceRange();
    message.count = object.count ?? 0;
    message.priceMin = object.priceMin ?? 0;
    message.priceMax = object.priceMax ?? 0;
    message.step = object.step ?? 0;
    return message;
  },
};

function createBasePriceRangeInfo(): PriceRangeInfo {
  return { minPrice: 0, maxPrice: 0, priceRangeList: [] };
}

export const PriceRangeInfo = {
  encode(
    message: PriceRangeInfo,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.minPrice !== 0) {
      writer.uint32(13).float(message.minPrice);
    }
    if (message.maxPrice !== 0) {
      writer.uint32(21).float(message.maxPrice);
    }
    for (const v of message.priceRangeList) {
      PriceRange.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PriceRangeInfo {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePriceRangeInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.minPrice = reader.float();
          break;
        case 2:
          message.maxPrice = reader.float();
          break;
        case 3:
          message.priceRangeList.push(
            PriceRange.decode(reader, reader.uint32())
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PriceRangeInfo {
    return {
      minPrice: isSet(object.minPrice) ? Number(object.minPrice) : 0,
      maxPrice: isSet(object.maxPrice) ? Number(object.maxPrice) : 0,
      priceRangeList: Array.isArray(object?.priceRangeList)
        ? object.priceRangeList.map((e: any) => PriceRange.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PriceRangeInfo): unknown {
    const obj: any = {};
    message.minPrice !== undefined && (obj.minPrice = message.minPrice);
    message.maxPrice !== undefined && (obj.maxPrice = message.maxPrice);
    if (message.priceRangeList) {
      obj.priceRangeList = message.priceRangeList.map((e) =>
        e ? PriceRange.toJSON(e) : undefined
      );
    } else {
      obj.priceRangeList = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<PriceRangeInfo>): PriceRangeInfo {
    const message = createBasePriceRangeInfo();
    message.minPrice = object.minPrice ?? 0;
    message.maxPrice = object.maxPrice ?? 0;
    message.priceRangeList =
      object.priceRangeList?.map((e) => PriceRange.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFilterList(): FilterList {
  return {
    items: undefined,
    favouriteFilters: undefined,
    priceRange: undefined,
  };
}

export const FilterList = {
  encode(
    message: FilterList,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.items !== undefined) {
      FilterItems.encode(message.items, writer.uint32(10).fork()).ldelim();
    }
    if (message.favouriteFilters !== undefined) {
      FavouriteFilters.encode(
        message.favouriteFilters,
        writer.uint32(42).fork()
      ).ldelim();
    }
    if (message.priceRange !== undefined) {
      PriceRangeInfo.encode(
        message.priceRange,
        writer.uint32(50).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FilterList {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.items = FilterItems.decode(reader, reader.uint32());
          break;
        case 5:
          message.favouriteFilters = FavouriteFilters.decode(
            reader,
            reader.uint32()
          );
          break;
        case 6:
          message.priceRange = PriceRangeInfo.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FilterList {
    return {
      items: isSet(object.items)
        ? FilterItems.fromJSON(object.items)
        : undefined,
      favouriteFilters: isSet(object.favouriteFilters)
        ? FavouriteFilters.fromJSON(object.favouriteFilters)
        : undefined,
      priceRange: isSet(object.priceRange)
        ? PriceRangeInfo.fromJSON(object.priceRange)
        : undefined,
    };
  },

  toJSON(message: FilterList): unknown {
    const obj: any = {};
    message.items !== undefined &&
      (obj.items = message.items
        ? FilterItems.toJSON(message.items)
        : undefined);
    message.favouriteFilters !== undefined &&
      (obj.favouriteFilters = message.favouriteFilters
        ? FavouriteFilters.toJSON(message.favouriteFilters)
        : undefined);
    message.priceRange !== undefined &&
      (obj.priceRange = message.priceRange
        ? PriceRangeInfo.toJSON(message.priceRange)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<FilterList>): FilterList {
    const message = createBaseFilterList();
    message.items =
      object.items !== undefined && object.items !== null
        ? FilterItems.fromPartial(object.items)
        : undefined;
    message.favouriteFilters =
      object.favouriteFilters !== undefined && object.favouriteFilters !== null
        ? FavouriteFilters.fromPartial(object.favouriteFilters)
        : undefined;
    message.priceRange =
      object.priceRange !== undefined && object.priceRange !== null
        ? PriceRangeInfo.fromPartial(object.priceRange)
        : undefined;
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
